import React, { useEffect } from 'react';
import { Button, Container, Row, Col, Card, Spinner, Image } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login: React.FC = () => {
  const { login, isInitializing, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Redirect to admin dashboard after successful authentication
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin');
    }
  }, [isAuthenticated, navigate]);

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Row>
        <Col>
          <Card style={{ width: '25rem' }} className="shadow">
            <Card.Body className="text-center">
              <Image 
                src="/qualrisk-logo.webp" 
                alt="QualRisk AI" 
                width="222" 
                height="40" 
                className="mb-3" 
              />
              <Card.Title className="mb-4">QAI Secure File Transfer Manager</Card.Title>
              <Card.Subtitle className="mb-3 text-muted">Admin Login</Card.Subtitle>
              <Card.Text>Sign in with your Microsoft account to access and manage your secure file transfers.</Card.Text>
              {isInitializing ? (
                <div className="text-center my-3">
                  <Spinner animation="border" role="status" variant="primary" />
                  <p className="mt-2">Initializing authentication...</p>
                </div>
              ) : (
                <Button 
                  variant="primary" 
                  onClick={login} 
                  className="w-100"
                  disabled={isInitializing}
                >
                  <i className="bi bi-microsoft me-2"></i>
                  Sign in with Microsoft
                </Button>
              )}
              
              <hr className="my-4" />
              
              <div className="text-muted">
                <small>
                  <Link to="/" className="text-decoration-none">
                    Client login
                  </Link>
                </small>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login; 